import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useAppSelector } from '../../app/hooks';
import { AnimatedDashboard } from '../../components/animation/AnimatedDashboard';
import Spinner from '../../components/common/Spinner';
import { Button, Flexed, PageTitle } from '../../styles/GlobalComponents';
import { claimCashback, getCashback } from './CashbackBonus.actions';
import {
  Section1,
  Section2,
  Section3,
  Section4,
  SectionInfo
} from './sections';
import { dateDifferenceInDays } from '../../helpers/helperFunctions';

export const CashbackBonus = () => {
  const { t } = useTranslation('cashback');
  const dispatch = useDispatch();

  const { info, statusPerPackage, loading } = useAppSelector(
    (state) => state.cashback
  );

  const licenceDate = dateDifferenceInDays(info?.dateFrom, info?.limitDate);

  useEffect(() => {
    dispatch(getCashback());
  }, [dispatch]);

  return (
    <AnimatedDashboard zoom>
      <>
        {loading ? (
          <Spinner fullScreen={true} />
        ) : (
          <div style={{ marginBottom: 100 }}>
            <Flexed between center>
              <PageTitle>{t('cashback_bonus')}</PageTitle>
              <Button
                onClick={() => dispatch(claimCashback())}
                maxWidth='200px'
                disabled={!info?.canClaimCashbackBonus}>
                {t('claim_cashback')}
              </Button>
            </Flexed>
            <SectionInfo days={licenceDate} />
            {info && (
              <>
                <Section1 cashback={info} />
                <Section2 cashback={info} statusPerPackage={statusPerPackage} />
                <Section3 cashback={info} />
              </>
            )}
            <Section4 />
          </div>
        )}
      </>
    </AnimatedDashboard>
  );
};
